import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterReset = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 4.5C10.5887 4.49912 9.93918 4.67428 9.36801 5.00749C8.79685 5.3407 8.32468 5.81994 8 6.396V4H7V8H11V7H8.8085C9.03116 6.56559 9.36556 6.19836 9.77728 5.93611C10.189 5.67385 10.6632 5.52605 11.151 5.5079C11.6388 5.48975 12.1226 5.60192 12.5527 5.83286C12.9827 6.0638 13.3435 6.40517 13.5978 6.82184C13.8521 7.2385 13.9908 7.71541 13.9996 8.20348C14.0084 8.69154 13.887 9.17314 13.6479 9.5987C13.4088 10.0243 13.0605 10.3784 12.6391 10.6247C12.2176 10.871 11.7381 11.0005 11.25 11H11V12H11.25C12.2446 12 13.1984 11.6049 13.9017 10.9017C14.6049 10.1984 15 9.24456 15 8.25C15 7.25544 14.6049 6.30161 13.9017 5.59835C13.1984 4.89509 12.2446 4.5 11.25 4.5Z",
			fill: "#CB7D61"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 3H2V4.5855L5.707 8.2925L6 8.5855V13H8V12H9V13C9 13.2652 8.89464 13.5196 8.70711 13.7071C8.51957 13.8946 8.26522 14 8 14H6C5.73478 14 5.48043 13.8946 5.29289 13.7071C5.10536 13.5196 5 13.2652 5 13V9L1.293 5.2925C1.10545 5.10501 1.00006 4.85069 1 4.5855V3C1 2.73478 1.10536 2.48043 1.29289 2.29289C1.48043 2.10536 1.73478 2 2 2H13V3Z",
			fill: "#CB7D61"
		})
	]
});
const ForwardRef = forwardRef(SvgFilterReset);
export default ForwardRef;
